import React from 'react'

import { ZeroesPad } from 'utils'

import { Form } from '_zari/core'

const SerieDocumentoFormGroup = ({ setFieldValue, onBlur, ...props }) => {
  const blurSerieDocumento = React.useCallback(
    e => {
      let valor = e.target.value
      if (/^[0-9]/.test(valor)) {
        valor = ZeroesPad(valor, 4)
      }

      valor = valor.toUpperCase()

      setFieldValue(props.name, valor)

      if (onBlur) {
        onBlur(e)
      }
    },
    [setFieldValue, props.name, onBlur]
  )

  return <Form.InputText {...props} maxLength={4} onBlur={blurSerieDocumento} />
}

export default React.memo(SerieDocumentoFormGroup)
